import { Intro } from '@/components/intro/intro';
import { IntroA } from '@/components/intro/introA/introA';
import { IntroB } from '@/components/intro/introB/introB';
import { IntroC } from '@/components/intro/introC/introC';
import { IntroD } from '@/components/intro/introD/introD';
import { IntroE } from '@/components/intro/introE/introE';
import { useSignUpRedirect } from '@/hooks/use-signup-redirect';
import { useAuth } from '@/store/useAuth';
import { Spiner } from '@/ui-kit';
import WebApp from '@twa-dev/sdk';
import { Navigate } from 'react-router-dom';
export function Home() {
    const { user } = useAuth((state) => state);
    const { generateSignUpPath } = useSignUpRedirect()

    if (
        user &&
        (
            user?.state === 'complete' ||
            user?.state === 'half_done'
        )
    )
        return <Navigate to="/app/browse" replace />
    
    /*
     * preventing redirects to telegram intro screens
     * intro web screen has already been shown
     */
    if (
        !WebApp.initData.length &&
        user?.registration_design
    ) return <Navigate to={generateSignUpPath()} replace />

    if (
        user &&
        user?.state === 'incomplete'
    ) {
        switch (user.start_screen_design) {
            case 'a':
                return <IntroA />
            case 'b':
                return <IntroB />
            case 'c':
                return <IntroC />
            case 'd':
                return <IntroD />
            case 'e':
                return <IntroE />
        }
        return <Intro />
    }
    return <Spiner />
}
